import { render, staticRenderFns } from "./DictationItemDesktop.vue?vue&type=template&id=c75dfc2a&scoped=true"
import script from "./DictationItemDesktop.vue?vue&type=script&lang=js"
export * from "./DictationItemDesktop.vue?vue&type=script&lang=js"
import style0 from "./DictationItemDesktop.vue?vue&type=style&index=0&id=c75dfc2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c75dfc2a",
  null
  
)

export default component.exports